// pages/Unauthorized.jsx
export default function Unauthorized() {
  return (
    <div style={{textAlign: "center", marginTop: "100px"}}>
      <h1>403</h1>
      <h2>Unauthorized Access</h2>
      <p>You don't have permission to access this page.</p>
    </div>
  );
}